export default function createMarkup(html: React.ReactNode) {
  return { __html: String(html) };
}
